import { render, staticRenderFns } from "./InventorySurplus.vue?vue&type=template&id=319b4077&scoped=true"
import script from "./InventorySurplus.vue?vue&type=script&lang=js"
export * from "./InventorySurplus.vue?vue&type=script&lang=js"
import style0 from "./InventorySurplus.vue?vue&type=style&index=0&id=319b4077&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319b4077",
  null
  
)

export default component.exports